import { InputAdornment, TextField } from "@mui/material";
import { existsString } from "../store/validation";

export const PercentageInput = ({
  baseNumber,
  errorText,
  caption,
  decimal = 0,
  label,
  left,
  onChanged,
  pctDecimal = 0,
  required,
  right,
  sx,
  valid,
  value,
}) => {
  const parsedBaseNumber = parseFloat(baseNumber);
  const percentValue = ((parseFloat(value) / parsedBaseNumber) * 100).toFixed(
    pctDecimal
  );

  const handlePct = (pctValue) => {
    let pct = parseFloat(pctValue);
    if (isNaN(pct)) pct = 0.0;
    if (pct > 99) pct = 99.0;
    const value = ((pct / 100.0) * parsedBaseNumber).toFixed(decimal);
    console.log("PCT " + pctValue + " V: " + value);
    if (onChanged) onChanged(value);
  };

  const handleChange = (event, decimal) => {
    let value = event.target.value;
    if (decimal === undefined || decimal === 0) {
      value = value.replace(/[^0-9]/g, "");
      handlePct(value);
    } else {
      const validNumber = new RegExp(/^\d*\.?\d*$/);
      if (validNumber.test(value)) handlePct(value);
    }
  };

  const getEndAdornment = (value) => {
    if (existsString(value)) {
      return <InputAdornment position="end">{value}</InputAdornment>;
    } else return undefined;
  };
  const getStartAdornment = (value) => {
    if (existsString(value)) {
      return <InputAdornment position="start">{value}</InputAdornment>;
    } else return undefined;
  };

  return (
    <TextField
      type="number"
      fullWidth
      label={label}
      helperText={valid ? caption : errorText}
      required={required}
      sx={sx}
      error={!valid}
      value={percentValue}
      onChange={(value) => handleChange(value)}
      slotProps={{
        htmlInput: { type: "number" },
        input: {
          type: "number",
          startAdornment: getStartAdornment(left),
          endAdornment: getEndAdornment(right),
        },
      }}
    />
  );
};
